import ky from 'ky';
import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';

const ELISE_BASE_URL = 'https://app.meetelise.com';
const FIVE_MINUTES_MS = 5 * 60 * 1000;

export interface IEliseAvailability {
    tourDurationInMinutes: number;
    availableTourStartTimes: string[];
}

interface IEliseAvailabilityResponse {
    availability: Record<string, IEliseAvailability>;
    calendarTimeZone: string;
}

/**
 * Called directly from the browser -- Elise's availability endpoint is public/unauthenticated,
 * and there is no backend involvement (no caching, no proxying) for this call.
 *
 * `startTime`/`endTime` should be ISO8601 strings with an offset, e.g. from
 * `dayjs().toISOString()`.
 */
export const useEliseAvailability = (
    buildingId: string | undefined,
    startTime: string,
    endTime: string,
) => {
    return useQuery(
        [queryKeys.eliseAvailability, buildingId, startTime, endTime],
        async () => {
            return ky.get(
                `${ELISE_BASE_URL}/api/pub/v1/buildings/${buildingId}/tour/availabilities`,
                {
                    searchParams: { startTime, endTime },
                    timeout: false,
                },
            ).json<IEliseAvailabilityResponse>();
        },
        {
            enabled: !!buildingId,
            refetchInterval: FIVE_MINUTES_MS,
            staleTime: FIVE_MINUTES_MS,
        }
    );
};
